import { say } from "../../words.ts";

/**
 * What the page says for a key the map server sends in an interaction's text in place of a sentence (ADR-120 decision
 * 5.3's clause for the time before `interactionLine`; ADR-058's amendment of 2026-10-10, point 4). The sentences are
 * the language files' (`thing.*` in `odyssey-lang`), whose keys are the keys the server sends; the page's own lines
 * on the message line are `hud.line.*`.
 *
 * @param text An interaction's text as the server sent it.
 * @returns The sentence for a key the page words, or null for anything else, which is shown as it came.
 */
export function thingLine(text: string): string | null {
  return isThingKey(text) ? say(text) : null;
}

/**
 * The keys of the sentences the page words for a thing.
 */
const THING_KEYS = ["thing.locked", "thing.unlocked", "thing.stuck"] as const;

/**
 * Whether a text is a key the page words for a thing.
 *
 * @param text An interaction's text.
 * @returns True for one of the keys.
 */
function isThingKey(text: string): text is (typeof THING_KEYS)[number] {
  return (THING_KEYS as readonly string[]).includes(text);
}
